<template>
  <div class="admin" style="min-height:300px;">
    <!-- Login -->
    <div v-if="!loginGranted" class="card-body" style="height:180px;">
      <form @submit.prevent="login">
        <div class="form-group">
          <label>Email:</label>
          <input
            id="email"
            required
            type="text"
            class="form-control names"
            v-model="creds.name"
          />
          <label>Password:</label>
          <input
            id="myInput"
            required
            type="password"
            class="form-control names"
            v-model="creds.password"
          />
          <div>
            <input
              type="checkbox"
              style="width: 40px;"
              class="form-control names"
              v-on:click="showPassword()"
            >Show Password
          </div>
        </div>
        <div class="form-group">
          <input
            type="submit"
            class="btn-submit"
            value="Submit"
          />
        </div>
      </form>
    </div>
    <!-- logged in as & logout-->
    <div v-if="loginGranted" class="placement" style="flex-direction: row;">
      <a class="placement"> Logged in as: {{ this.userName.split('@')[0] }}</a>
      <div class="placement">
        <input
          type="submit"
          class="btn-submit"
          value="Logout"
          style="width:140px;"
          v-on:click="logout()"
        />
      </div>
    </div>
      <!-- token generator -->
    <div v-if="loginGranted" class="placement">
      <div class="placement">
        <span v-tooltip.top.click="{
              content: 'Token Copied!',
              class: 'tooltip-custom'
          }"
        >
          <input id="copiedToken" v-on:click="copiedText('copiedToken')" :value="generate">
        </span>
        <div id="example">
          <button v-on:click="generateToken" >Generate New Token</button>
        </div>
      </div>
      <!-- ops url updating -->
      <div class="placement">
        <span>
          <input id="copiedOps" v-model="opsurl">
        </span>
        <div id="example">
          <span v-tooltip.right.click="{
              content: 'Url Stored!',
              class: 'tooltip-custom'
            }"
          >
            <button v-on:click="storeOps" >Store OPS url</button>
          </span>
        </div>
      </div>
    </div>
    <!-- Image uploader -->
    <Div v-if="loginGranted" class="form-group">
      <label class="uploadbutton" style="margin-bottom: 20px;">
      <input
        style="display: none;"
        type="file"
        id="file"
        ref="myFiles"
        accept="image/*"
        @change="storeFiles"
      >Click to upload picture to 'Images' page
      </label>
    </Div>
    <!-- Image view/deletor -->
    <div v-if="loginGranted" class="overalllayout1">
      <div v-for="info in pageOfImages" v-bind:key="info.id">
        <div class="borderlayout1" style="width:227.5px;">
          <div class="profileimage1" style="width:80%;">
            <img class="imagesize1" :src="info.imageURL" />
          </div>
          <button
            class="button-border"
            v-on:click="deletePic(info.name)"
          >Delete the Image
          </button>
        </div>
      </div>
    </div>
    <div v-if="loginGranted" class="card-footer">
      <jw-pagination :pageSize="12" :items="images" @changePage="onChangePage2"></jw-pagination>
    </div>
    <!-- testimony view/deletor  -->
    <div v-if="loginGranted" class="overalllayout1">
      <div v-for="info in pageOfItems" v-bind:key="info.id">
        <div class="borderlayout1">
          <div class="profileimage1">
            <img class="imagesize1" :src="info.imageURL" />
          </div>
          <div class="infolayout1">
            <p class="titleinfo1"><b>Name: </b>{{ info.name }}</p>
            <p class="titleinfo1"><b>Location: </b>{{ info.location }}</p>
          </div>
          <button
            class="button-border"
            v-on:click="deleteDoc(info.id, info.imageName)"
          >Delete Testimony
          </button>
        </div>
      </div>
  </div>
    <div v-if="loginGranted" class="card-footer">
      <jw-pagination :pageSize="9" :items="testimony" @changePage="onChangePage"></jw-pagination>
    </div>
  </div>
</template>

<script>
import db from '../../config/db'

export default {
  data () {
    return {
      generate: '',
      testimony: [],
      pageOfItems: [],
      files: '',
      images: [],
      pageOfImages: [],
      opsurl: '',
      loginGranted: this.$store.state.accessGranted,
      creds: {
        name: '',
        password: ''
      },
      userName: this.$store.state.username
    }
  },

  mounted () {
    this.getToken()
    this.getDB()
    this.FirebaseImages()
    this.getOps()
    this.$store.commit('checkENV')
  },

  methods: {
    login () {
      const vm = this
      db.app.auth()
        .signInWithEmailAndPassword(this.creds.name, this.creds.password)
        .then(() => {
          db.app.auth().onAuthStateChanged(async (user) => {
            vm.creds = {}
            vm.$store.commit('checkAccess', true)
            vm.$store.commit('displayName', user.email)
            await window.location.reload()
          })
        })
        .catch((error) => {
          console.log(error.message)
          vm.$store.commit('checkAccess', false)
        })
    },
    logout () {
      db.app.auth().signOut().then(async () => {
        this.$store.commit('checkAccess', false)
        this.$store.commit('displayName', '')
        await window.location.reload()
      })
    },
    showPassword () {
      const x = document.getElementById('myInput')
      if (x.type === 'password') {
        x.type = 'text'
      } else {
        x.type = 'password'
      }
    },
    getToken () {
      const vm = this
      db.firestore
        .collection('token' + this.$store.state.env)
        .doc('access')
        .get()
        .then(function (doc) {
          vm.generate = doc.data().token
        })
    },
    storeToken () {
      db.firestore
        .collection('token' + this.$store.state.env)
        .doc('access')
        .update({ token: this.generate })
    },
    generateToken () {
      this.generate = Math.random().toString(36)
        .substring(3).toUpperCase()
      this.storeToken()
    },
    copiedText (value) {
      const copyText = document.getElementById(value)
      copyText.select()
      copyText.setSelectionRange(0, 99999)
      document.execCommand('copy')
    },
    storeOps () {
      db.firestore
        .collection('opsURL' + this.$store.state.env)
        .doc('opsURL')
        .update({ url: this.opsurl })
    },
    getOps () {
      const vm = this
      db.firestore
        .collection('opsURL' + this.$store.state.env)
        .doc('opsURL')
        .get()
        .then(function (doc) {
          vm.opsurl = doc.data().url
        })
    },
    storeFiles () {
      const fileInfo = this.$refs.myFiles.files[0]
      db.storing.ref(
        'gallery' + this.$store.state.env + '/' +
        fileInfo.name
      ).put(fileInfo)
        .then(setTimeout(() => { this.FirebaseImages() }, 2000))
    },
    getDB () {
      const vm = this
      let testimonyinfo = []
      let data = {}
      db.firestore.collection('testimony' + this.$store.state.env)
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            // Using image name to obtain image url
            db.storing.ref('images' + this.$store.state.env + '/')
              .child(doc.data().imageName)
              .getDownloadURL()
              .then((downloadURL) => {
                data = {
                  id: doc.id,
                  name: doc.data().name,
                  imageName: doc.data().imageName,
                  location: doc.data().location,
                  imageURL: downloadURL,
                  timestamp: doc.data().timestamp
                }
                testimonyinfo.push(data)
                testimonyinfo = testimonyinfo.sort(
                  (a, b) => b.timestamp - a.timestamp
                )
              })
          })
        })
      vm.testimony = testimonyinfo
    },
    deleteDoc (docId, imageName) {
      db.firestore.collection('testimony' + this.$store.state.env)
        .doc(docId).delete()
        .then(() => {
          if (imageName !== 'no-image.png') {
            db.storing.ref('images' + this.$store.state.env)
              .child(imageName).delete()
              // .then(() => {
              //   this.getDB()
              // })
          }
          this.getDB()
        })
    },
    deletePic (value) {
      db.storing.ref('gallery' + this.$store.state.env)
        .child(value).delete()
        .then(() => { this.FirebaseImages() })
        .catch((error) => {
          console.error('Error removing image: ', error)
        })
    },
    FirebaseImages () {
      const vm = this
      let ImageList = []
      let i = 1

      db.storing.ref('gallery' + this.$store.state.env + '/')
        .listAll()
        .then((res) => {
          res.items.forEach((itemRef) => {
            const dbInfo = db.storing.ref('gallery' + this.$store.state.env + '/').child(itemRef.name)
            dbInfo
              .getDownloadURL()
              .then((downloadURL) => {
                dbInfo
                  .getMetadata()
                  .then((metadata) => {
                    ImageList.push(
                      {
                        id: i,
                        name: metadata.name,
                        imageURL: downloadURL,
                        date: new Date(metadata.timeCreated)
                      }
                    )
                    i++
                    ImageList = ImageList.sort((a, b) => b.date - a.date)
                  })
              })
          })
          vm.images = ImageList
        })
    },
    onChangePage (pageOfItems) {
      this.pageOfItems = pageOfItems
    },
    onChangePage2 (pageOfImages) {
      this.pageOfImages = pageOfImages
    }
  }
}

</script>

<style lang="scss">
@import "../assets/common.scss";

.placement {
  margin-top: 25px;
  display: flex;
  justify-content: center;
  margin: 20px;

  @media (max-width: 760px) {
    flex-direction: column;
  }
}

.overalllayout1 {
  width: 75%;
  display: flex;
  flex-wrap: wrap;
  margin: 0 auto;

  @media (max-width: 760px) {
    flex-direction: column;
    width: auto;
  }
}

.borderlayout1 {
  display: flex;
  margin : 0 auto;
  height: 95px;
  width: 380px;
  box-sizing: border-box;
  border: .1px solid $content-colour;
  margin-bottom: 5px;
  margin-top: 5px;
  overflow: hidden;
  text-overflow: ellipsis;

  @media (max-width: 760px) {
      width: auto;
    }

  .profileimage1 {
    height: 100%;
    width: 25%;

    .imagesize1 {
      max-height: 100%;
      max-width: 100%;
    }
  }

  .infolayout1 {
    width: 75%;
    box-sizing: border-box;
    border-left: .1px solid $content-colour;

    @media (max-width: 760px) {
      width: 65%;
    }
  }

  .titleinfo1 {
    text-align: left;
    margin-left: 10px;
    margin-top: 10px;
  }

}

.button-border {
  padding: 0;
  border: none;
  border-left: .1px solid $content-colour;
}

</style>
